import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import currency from 'currency.js';

import './welcome-item.scss';
import { s3Link } from '../../utils/constants';
import AlertConfirmModal from '../../common/AlertConfirmModal';

const WelcomeItem = ({ welcome, fetch, setFetch, setActiveWelcome }) => {
    const [busy, setBusy] = useState(false);
    const [deletingIds, setDeletingIds] = useState([]);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);

    const handleEdit = () => {
        setActiveWelcome(welcome);
    };

    const confirmDelete = () => {
        setShowConfirmDelete(true);
    };

    const handleDelete = async () => {
        setBusy(true);
        let tmp = [...deletingIds];
        tmp.push(welcome.id);
        setDeletingIds([...tmp]);

        await axios.delete(`/api/welcome-messages/${welcome.id}`)
            .then(response => {
                setFetch(fetch => fetch + 1);
            });
    };

    return <div
        key={welcome.id}
        className={`welcome-message-item${busy && deletingIds.indexOf(welcome.id) >= 0 ? ' welcome-message-item--deleting' : ''}`}
    >
        <div className='welcome-message-item__actions'>
            <Dropdown drop="down">
                <Dropdown.Toggle
                    className='welcome-message-item__dropdown'
                    variant='link'
                >
                    <span className="album_three_dot">
                        <i className='fa-solid fa-ellipsis-v'></i>
                    </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item onClick={handleEdit}>Edit</Dropdown.Item>
                    <Dropdown.Item onClick={confirmDelete}>Delete</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
        <div className='welcome-message-item__caption drag-handler'>
            {welcome.wm_caption} <br />
            <strong className='welcome-message-price'>
                {
                    welcome.wm_price > 0
                        ? (welcome.promo_price > 0 ? <><strike>{currency(welcome.wm_price).format({ precision: 2 })}</strike><span>{currency(welcome.promo_price).format({ precision: 2 })}</span></> : currency(welcome.wm_price).format({ precision: 2 }))
                        : 'Free'
                }
            </strong>
        </div>
        <div className='welcome-message-item__thumb'>
            {
                welcome.free_preview && Object.keys(welcome.free_preview).length > 0
                    ? <img
                        src={`${s3Link}/${welcome.free_preview.thumb_path ?? welcome.free_preview.large_path}`}
                        width="64"
                        height="64"
                        id={welcome.free_preview.media_id}
                    />
                    : ''
            }
            {
                (!welcome.free_preview || Object.keys(welcome.free_preview).length <= 0) && welcome.medias && welcome.medias.length > 0
                    ? <img
                        src={`${s3Link}/${welcome.medias[0].thumb_path ?? welcome.medias[0].large_path}`}
                        width="64"
                        height="64"
                        id={welcome.medias[0].media_id}
                    />
                    : ''
            }
        </div>

        <AlertConfirmModal
            modalBody={`Are you sure you want delete the welcome message?`}
            show={showConfirmDelete}
            setShow={setShowConfirmDelete}
            isConfirm={true}
            useFunction={handleDelete}
            busy={busy}
        />
    </div>;
};

export default WelcomeItem;